<template>
    <div v-if="isVisible" class="test-modal-overlay" @click="closeModal">
        <div class="test-modal" @click.stop>
            <!-- Header -->
            <div class="test-modal-header">
                <h3>{{ title }}</h3>
                <button class="close-button" @click="closeModal">×</button>
            </div>

            <!-- Content -->
            <div class="test-modal-body">
                <slot name="content">{{ content }}</slot>
            </div>

            <!-- Footer -->
            <div class="test-modal-footer">
                <slot name="actions">
                    <button v-for="(action, index) in actions" :key="index" :class="action.class"
                        @click="action.handler">
                        {{ action.text }}
                    </button>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, toRefs } from "vue";

export default defineComponent({
    name: "DynamicModal",
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Modal Title",
        },
        content: {
            type: String,
            default: "Modal content goes here.",
        },
        actions: {
            type: Array,
            default: () => [
                {
                    text: "Close",
                    class: "btn-close",
                    handler: () => { },
                },
            ],
        },
    },
    emits: ["close"],
    setup(props, { emit }) {
        const { isVisible, title, content, actions } = toRefs(props);

        const closeModal = () => {
            emit("close");
        };

        return {

            closeModal,
        };
    },
});
</script>

<style scoped>
.test-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.test-modal {
    background: #fff;
    border-radius: 8px;
    max-width: 500px;
    width: 100%;
    padding: 1.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    position: relative;
}

.test-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.test-modal-header h3 {
    margin: 0;
    font-size: 1.25rem;
}

.close-button {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
}

.test-modal-body {
    margin-bottom: 1rem;
    font-size: 1rem;
}

.test-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
}

.btn-close {
    background-color: #ff4d4f;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
}

.btn-close:hover {
    background-color: #d4380d;
}
</style>
